/* eslint-disable sort-keys */
/* eslint-disable sort-keys-fix/sort-keys-fix */

const palette = {
  // Blue shades (Dark to Light)
  bigStone: '#152343',
  biscay: '#153A62',
  blueWood: '#27324B',
  orient: '#004A7C',
  ocean: '#0068AF',
  azure: '#3558A8',
  cerulean: '#10ADE4',
  ceruleanAlpha10: 'rgba(16, 173, 228, 0.1)',
  powderBlue: '#B2D5E5',
  // Gray shades (Light to Dark)
  gray0: '#F8F8F8',
  gray1: '#EEF2F5',
  gray2: '#CCC',
  gray3: '#999B9E',
  gray4: '#757679',
  gray5: '#545456',
  gray6: '#383838',
  gray7: '#040d25',
  // Other
  gold: '#FFCA00',
  royal: '#FFD533',
  green: '#47B881',
  red: '#F36331',
  yellow: '#F7C653',
  // Generic
  transparent: 'rgba(0, 0, 0, 0)',
  white: '#FFF',
  whiteAlpha75: 'rgba(255, 255, 255,0.75)',
  whiteAlpha50: 'rgba(255, 255, 255,0.50)',
  whiteAlpha25: 'rgba(255, 255, 255, 0.25)',
  whiteAlpha10: 'rgba(255, 255, 255, 0.10)',
  whiteAlpha05: 'rgba(255, 255, 255, 0.05)',
  black: '#000',
  blackAlpha75: 'rgba(0, 0, 0, 0.75)',
  blackAlpha50: 'rgba(0, 0, 0, 0.50)',
  blackAlpha25: 'rgba(0, 0, 0, 0.25)',
  blackAlpha10: 'rgba(0, 0, 0, 0.10)',
  blackAlpha05: 'rgba(0, 0, 0, 0.05)'
}

export default palette
